export default __webpack_public_path__ + "static/media/2930 knife block B side.699c6b65.png";